import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AccordionModule, CollapseModule, DatepickerModule,
    TimepickerModule, ModalModule, TabsModule, CarouselModule, BsDatepickerModule, ButtonsModule
} from 'ngx-bootstrap';
import { EmitterService } from '../../services/emitter.service';
import { PopupComponent } from '../popup/popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2CompleterModule } from 'ng2-completer';
import { DoubleDigitPipe } from '../pipes/DoubleDigit.pipe';
import { SpacePipe } from '../pipes/SpacePipe.pipe';
import { TypeaheadModule } from 'ngx-bootstrap';
import { ReloadDirective } from '../../directive/reload.directive';
import { PlanAppSummaryComponent } from 'src/app/planAppSummary/planAppSummary.component';
import { LoaderComponent } from './../../../loader/loader.component';
import { DrawerComponent } from '../drawer/drawer.component';
import { NeedHelpComponent } from './../../../needHelp/needHelp.component';
import { PlanCardComponent } from './../../components/planCard/planCard.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { QuicklinkModule } from 'ngx-quicklink';
import { HeaderComponent } from 'src/app/header/header.component';
import { ToggleSwitchComponent } from 'src/app/toggle-switch/toggle-switch.component';
import { UiStyleToggleService } from '../../services/ui-style-toggle.service';
import { PlanRightSidepipelineComponent } from 'src/app/plan-right-sidepipeline/plan-right-sidepipeline.component';
import { SummaryCardComponent } from '../../components/summary-card/summary-card.component';
import { ProgressCircleComponent } from '../../components/progress-circle/progress-circle.component';
import { CustomAutoCompleterComponent } from '../../components/custom-auto-completer/custom-auto-completer.component';
import { DropdownPlanPipelineComponent } from '../../components/dropdown-plan-pipeline/dropdown-plan-pipeline.component';
import { FooterComponent } from 'src/app/footer/footer.component';
import { HttpRequestInterceptor } from '../../interceptors/http-request.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateFormatterPipe } from '../pipes/DateFormatterPipe.pipe';
import { OnlyNumbersDirective } from '../../directive/only-numbers.directive';
import { WhitespaceRemoveDirective } from '../../directive/whitespace-remove.directive';
import { CustomBhSeriesSmartsearchComponent } from '../../components/custom-bh-series-smartsearch/custom-bh-series-smartsearch.component';
import { AlphabetOnlyDirective } from '../../directive/character-only.directive';
export function themeFactory(themeService: UiStyleToggleService) {
    return () => themeService.setThemeOnStart();
}
// Application wide providers
const APP_PROVIDERS = [
    EmitterService
];
@NgModule({
    declarations: [
        PopupComponent,
        DoubleDigitPipe,
        SpacePipe,
        DateFormatterPipe,
        ReloadDirective,
        PlanAppSummaryComponent,
        LoaderComponent,
        DrawerComponent,
        NeedHelpComponent,
        PlanCardComponent,
        HeaderComponent,
        ToggleSwitchComponent,
        PlanRightSidepipelineComponent,
        SummaryCardComponent,
        ProgressCircleComponent,
        CustomAutoCompleterComponent,
        CustomBhSeriesSmartsearchComponent,
        DropdownPlanPipelineComponent,
        FooterComponent,
        OnlyNumbersDirective,
        WhitespaceRemoveDirective,
        AlphabetOnlyDirective
    ],
    imports: [
        QuicklinkModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        Ng2CompleterModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AccordionModule.forRoot(),
        CarouselModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ButtonsModule.forRoot(),
        TypeaheadModule.forRoot(),
        RatingModule.forRoot()
    ],
    exports: [
        QuicklinkModule,
        ModalModule,
        ReactiveFormsModule,
        TabsModule,
        PopupComponent,
        AccordionModule,
        Ng2CompleterModule,
        CarouselModule,
        DoubleDigitPipe,
        SpacePipe,
        BsDatepickerModule,
        ButtonsModule,
        ReloadDirective,
        PlanAppSummaryComponent,
        LoaderComponent,
        DrawerComponent,
        NeedHelpComponent,
        PlanCardComponent,
        RatingModule,
        HeaderComponent,
        ToggleSwitchComponent,
        PlanRightSidepipelineComponent,
        SummaryCardComponent,
        ProgressCircleComponent,
        CustomAutoCompleterComponent,
        CustomBhSeriesSmartsearchComponent,
        DropdownPlanPipelineComponent,
        FooterComponent,
        DateFormatterPipe,
        OnlyNumbersDirective,
        WhitespaceRemoveDirective,
        AlphabetOnlyDirective
    ],
    providers: [
        UiStyleToggleService,
        {
            provide: APP_INITIALIZER,
            useFactory: themeFactory,
            deps: [UiStyleToggleService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        }
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [APP_PROVIDERS]
        };
    }
}
